import axios from "axios";

import { config } from "../../config";
import { passengersApiPrefix } from "../../paths";

const END_POINT: string = `${passengersApiPrefix}/assign_default_by_business`;

export interface IAssignDefaultTravelerByBusinessRequest {
  travelerId: string;
  businessId: string;
  userId: string;
}

export const assignDefaultTravelerByBusiness = async (
  body: IAssignDefaultTravelerByBusinessRequest
): Promise<void> => {
  await axios.put(END_POINT, body, { baseURL: config.baseURL });
};
